import styled from 'styled-components';

export const BkIncModalHeader = styled.div`
  padding: 2.4rem 3rem 1.2rem;
  h3 {
    font-size: 2.2rem;
    font-weight: 700;
    color: #141823;
  }
`;

export const BkIncModalInfo = styled.div`
  background-color: #e7f5ef;
  padding: 0.9rem 3rem;
  display: flex;
  align-items: center;
  span {
    font-size: 1.4rem;
    color: #18a160;
    margin-left: 0.9rem;
  }
`;

export const BkIncModalContent = styled.div`
  max-height: 80vh;
  overflow-y: auto;
  scroll-behavior: smooth;
`;

export const BkIncModalBody = styled.div`
  // padding: 2.3rem 3rem 2rem;
  padding: ${props => (props.isMweb ? '0 11.6px 0 11.6px' : '2.3rem 3rem 2rem')};
  .bkIncModal__img {
    height: ${props => (props.isMweb ? `20.4rem` : `28rem`)};
    border-radius: 0.4rem;
    width: 100%;
    object-fit: cover;
    margin-bottom: 1.3rem;
  }
  ${props =>
    props.isMweb
      ? `.dinning-section{
          padding: 2rem 0;
          border-bottom: 0.1rem #E4E4E4 solid;
          :first-child{
            padding-top: 0;
          }
          :last-child{
            border-bottom:none;
          }
        }`
      : ``}
  .greyH4 {
    font-size: 1.8rem;
    font-weight: 700;
    color: #ff3a5c;
    line-height: 2.4rem;
    margin-bottom: 0.8rem;
  }
  h4 {
    ${props =>
      props.isMweb
        ? `font-size: 1.4rem;
        line-height: 1.7rem;
        font-weight: 600;
        margin-bottom: 2rem;`
        : `font-size: 1.8rem;
        font-weight: 700;
        line-height: 2.4rem;
        margin-bottom: 0.8rem;
    `}
    color: #141823;
  }
  p {
    font-size: 1.4rem;
    color: #141823;
    line-height: 2rem;
    margin-bottom: 2.5rem;
  }
`;

export const BkIncModalFooter = styled.div`
  padding: 2.5rem 3rem;
  background: #ffffff;
  border-top: 0.1rem solid rgba(199, 199, 199, 0.87);
  border-radius: 0 0 1rem 1rem;
  .bookInclusiveBtn {
    border-radius: 3rem;
    background-color: #ff6e39;
    box-shadow: 0 0.2rem 1.2rem rgba(0, 0, 0, 0.137568);
    display: inline-block;
    flex-shrink: 0;
    color: #fff;
    text-transform: uppercase;
    font-size: 1.6rem;
    font-weight: 900;
    padding: 1.6rem 2rem;
    cursor: pointer;
    outline: 0;
    text-align: center;
    width: 100%;
  }
`;

export const BkIncModalList = styled.div`
  margin-bottom: ${props => props.marginBtm || '2.5rem'};
  .bkIncModal__list--item {
    display: flex;
    font-size: ${props => (props.isMweb ? `1.2rem` : `1.4rem`)};
    line-height: 1.8rem;
    margin-bottom: 1rem;
    position: relative;
    padding-left: 15px;
    ${props => (props.isMweb ? `color:#4A4A4A` : ``)};
  }
  .bkIncModal__list--item:last-child {
    margin-bottom: 0;
  }
  .bkIncModal__list--itemIcon {
    padding-top: 0.3rem;
    flex-shrink: 0;
    margin-right: 0.9rem;
  }

  .bkIncModal__list--item::before {
    background-color: #b0b0b0;
    border-radius: 50%;
    content: '';
    height: 6px;
    left: 0;
    position: absolute;
    top: 8px;
    width: 6px;
  }
`;

export const InclusiveWrapper = styled.div`
  background-color: ${props => (props.isMweb ? '#fff' : props.theme.colors.ash.dark)};
`;
